import { render, staticRenderFns } from "./UnapprovedClientsList.vue?vue&type=template&id=ee62b588&scoped=true"
import script from "./UnapprovedClientsList.vue?vue&type=script&lang=js"
export * from "./UnapprovedClientsList.vue?vue&type=script&lang=js"
import style0 from "./UnapprovedClientsList.vue?vue&type=style&index=0&id=ee62b588&prod&scoped=true&lang=css"
import style1 from "./UnapprovedClientsList.vue?vue&type=style&index=1&id=ee62b588&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee62b588",
  null
  
)

export default component.exports